import { BaseDO } from './BaseDO';
import { PostsService } from '../services/posts.service';

export class AllSizesImageDO extends BaseDO {
  thumbnail: string;
  medium: string;
  mediumLarge: string;
  large: string;
  full: string;

  protected getPrimitivePropertyKeys(): string[] {
    return [
      'thumbnail',
      'medium',
      'mediumLarge',
      'large',
      'full',
    ];
  }

  buildFromObject(object: object) {
    super.buildFromObject(object);
    this.mediumLarge = object['medium_large'];
  }
}

export class PostDO extends BaseDO {
  id: number;
  slug: string;
  date: string;
  modified: string;
  status: string;
  type: string;
  title: { rendered: string };
  content: { rendered: string };
  excerpt: { rendered: string };
  author: number;
  featuredMedia: number;
  categories: number[];
  parsedCategories: string[];
  tags: string[];
  featuredImage: string;
  featuredImageSizes: AllSizesImageDO;
  allImages: string[];
  allSizesImages: Array<AllSizesImageDO>;
  excerptTags: string[];
  readableTagNames: string[];

  protected getPrimitivePropertyKeys(): string[] {
    return [
      'id',
      'slug',
      'title',
      'date',
      'modified',
      'status',
      'type',
      'content',
      'excerpt',
      'author',
      'categories',
      'tags',
      'featuredMedia',
      'allImages',
      'allSizesImages',
      'excerptTags',
      'readableTagNames',
    ];
  }

  buildFromObject(object: object) {
    super.buildFromObject(object);
    this.featuredMedia = object['featured_media'];
    this.featuredImage = object['fimg_url'];
    this.allImages = object['all_images'];

    if (object['all_images2']) {
      this.allSizesImages = object['all_images2'].map((imageData) => {
        const imageSizes = new AllSizesImageDO();
        imageSizes.buildFromObject(imageData);
        return imageSizes;
      });
    }

    if (object['fimg_url2']) {
      this.featuredImageSizes = new AllSizesImageDO();
      this.featuredImageSizes.buildFromObject(object['fimg_url2']);

      if (!this.featuredImage) {
        this.featuredImage = this.featuredImageSizes.full ? this.featuredImageSizes.full : 'assets/logo.svg';
      }
    }

    if (object['categories']) {
      this.parsedCategories = object['categories'].map((categoryId) => {
        switch (categoryId) {
          case PostsService.OFFLINE_ACTIVITIES:
            return 'Activitate offline';
          case PostsService.ONLINE_ACTIVITIES:
            return 'Activitate online';
          case PostsService.PRESCHOOL_ACTIVITIES:
            return 'Preșcolari';
          case PostsService.PRIMARY_SCHOOL:
            return 'Școala primară';
          case PostsService.GYMNASIUM:
            return 'Gimnaziu';
          case PostsService.HIGH_SCHOOL:
            return 'Liceu';
          case PostsService.MOBILE:
            return 'Telefon';
          case PostsService.DESKTOP:
            return 'Laptop';
          case PostsService.BLOG_POSTS:
            return 'Blog';
          case PostsService.CARTOONS_PAGES:
            return 'Desen animat';
          case PostsService.SONGS_PAGES:
            return 'Cântec';
          case PostsService.REVIEW_PAGE:
            return 'Recenzie';
          case PostsService.REVIEWS_ONLINE_GAMES:
            return 'Recenzie joc online';
          case PostsService.REVIEWS_OFFLINE_GAMES:
            return 'Recenzie joc offline';
          case PostsService.REVIEWS_BOOKS:
            return 'Recenzie carte';
          case PostsService.COLORING_PAGES:
            return 'Planșe de colorat';
          case PostsService.CRAFTS_PAGES:
            return 'Lucru manual';
        }
      }).filter((item => item != null));
    }

    this.excerptTags = this.excerpt.rendered.replace(/(<([^>]+)>)/ig, '').split(', ');

    if (object['readable_tag_names']) {
      this.readableTagNames = object['readable_tag_names'];
    }
  }
}

export class PostsDataDO extends BaseDO {
  posts: PostDO[];
  pagesCount: number;
  itemsCount: number;

  protected getPrimitivePropertyKeys(): string[] {
    return ['posts', 'pagesCount', 'itemsCount'];
  }

  buildFromObject(object: object) {
    super.buildFromObject(object);
    this.pagesCount = Number(object['pagesCount']);
    this.itemsCount = Number(object['itemsCount']);
    if (object['posts']) {
      this.posts = object['posts'].map((postData) => {
        const post = new PostDO();
        post.buildFromObject(postData);
        return post;
      });
    }
  }
}
